import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthorizationInterceptor } from './auth.interceptor';
import { ErrorHandlerInterceptor } from '@buyiq-core/auth/error-handler.interceptor';

export const httpsInterceptorProvider = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
];
